import { Stack } from 'components/Stack';
import { useDetectDevice, useLocationConsent } from 'hooks';
import { DropOffList } from '../DropOffList';
import { MapView } from '../MapView';
import { QuantityDropOffFound, SearchDropOff } from './components';
import {
  CustomScrollbar,
  DropOffLocationsContainer,
  MapViewContainer,
} from './DropOffLocationsLayout.styles';
import { useDropOffLocationLayout } from './useDropOffLocationLayout';

export interface IDropOffLocationsLayoutProps {
  searchDropOffLocationsFn: (
    organizationSlug: string,
    organizationId: number,
    values: { postalCode: string; countryCode: string; carrierId?: string },
  ) => Promise<{ locations: any[] }>;
  onSelectDropOff?: (dropOff: any) => void;
  carrierId?: string;
}

export function DropOffLocationsLayout({
  searchDropOffLocationsFn,
  onSelectDropOff,
  carrierId,
}: IDropOffLocationsLayoutProps) {
  const { isMobile } = useDetectDevice();

  const {
    dropOffs,
    center,
    isLoading,
    error,
    onDropOffClick,
    onSearchDropOffLocations,
  } = useDropOffLocationLayout({
    searchDropOffLocationsFn,
    carrierId,
  });

  const { isAllowGoogleMaps } = useLocationConsent();

  return (
    <Stack>
      <DropOffLocationsContainer isMapAvailable={isAllowGoogleMaps}>
        <SearchDropOff
          isLoading={isLoading}
          onSearch={onSearchDropOffLocations}
        />
        <CustomScrollbar>
          <QuantityDropOffFound quantity={dropOffs.length} />
          <DropOffList
            dropOffs={dropOffs}
            isLoading={isLoading}
            error={error}
            onDropOffClick={onDropOffClick}
            onSelectDropOff={onSelectDropOff}
          />
        </CustomScrollbar>
      </DropOffLocationsContainer>
      {!isMobile && isAllowGoogleMaps && (
        <MapViewContainer>
          <MapView center={center} isDropOffEmpty={dropOffs.length === 0} />
        </MapViewContainer>
      )}
    </Stack>
  );
}
